import gsap from 'gsap';

import { Container, Point, Sprite, Texture } from 'pixi.js';
import { MonoBehavior } from './core/monoBehavior';
import { getAsset } from './preloadGameAssets';
import { lerp } from './core/lerp';
import { addToUI } from './core/Playable2DRootContainer';
import { Layout } from './LayoutManager';
import { Power1 } from 'gsap';
import { Time } from './core/pixiRenderer';
const DURATION = 1200;
const POSITION_DELTA = 0.32;
export class MagicUIParticles extends MonoBehavior {
    private particleContainer: Container;
    private particles = [] as ParticleItem[];
    particleCount: number;

    constructor(parentContainer: Container, particleCount = 15) {
        super();
        this.loadParticle = this.loadParticle.bind(this);
        this.particleContainer = new Container();
        const pos = new Point();
        parentContainer.getGlobalPosition(pos);

        this.particleContainer.position = pos;
        addToUI(this.particleContainer);
        this.particleCount = particleCount;
    }
    start(): void {
        this.loadParticle();
    }
    async loadParticle() {
        const assetStar = await getAsset('particles/particleStar');
        const assetDot = await getAsset('particles/particleDot');
        const txtStar = new Texture(assetStar);
        const txtDot = new Texture(assetDot);

        while (this.particleCount > 0) {
            const txt = this.particleCount % 2 == 0 ? txtStar : txtDot;
            this.particles.push(new ParticleItem(this.particleContainer, txt, this.particleCount));
            this.particleCount--;
        }
        setTimeout(this.destroy, DURATION);
    }
}

class ParticleItem extends MonoBehavior {
    targetPosition: Point;
    sprite: Sprite;
    startTime = 0;
    container: Container;
    popActive = false;
    yoyo = [] as gsap.core.Tween[];
    duration: number;
    startPosition: any;
    rotation: number;
    constructor(particleContainer: Container, texture: Texture, fractal: number) {
        super();

        const buttonSize = Layout.getButtonSize();
        this.startTime = performance.now();
        this.rotation = lerp(-0.01, 0.01, Math.random());

        this.sprite = new Sprite(texture);
        this.sprite.anchor.set(0.5);
        this.container = new Container();
        this.container.scale.set(0.2);
        this.container.position.x = lerp(-buttonSize * 0.6, buttonSize * 0.6, Math.random());
        this.container.position.y = lerp(-buttonSize * 0.6, buttonSize * 0.6, Math.random());
        this.targetPosition = new Point(
            this.container.position.x + buttonSize * lerp(-POSITION_DELTA, POSITION_DELTA, Math.random()),
            this.container.position.y + buttonSize * lerp(-POSITION_DELTA, POSITION_DELTA, Math.random())
        );
        this.startPosition = this.container.position.clone();
        this.container.addChild(this.sprite);
        const particleScale = Layout.getParticleScale();

        this.sprite.scale.set(lerp(particleScale * 0.4, particleScale * 2.5, Math.random()));
        particleContainer.addChild(this.container);
        this.duration = lerp(DURATION * 0.4, DURATION, Math.random());
        gsap.to(this.container.scale, {
            x: 0.4,
            y: 0.4,
            duration: this.duration / 1000,
            delay: lerp(0.1, 0.2, Math.random()),
        }).then(() => {
            this.yoyo.push(
                gsap.to(this.container.scale, {
                    x: 0.7,
                    y: 0.7,
                    duration: lerp(1.3, 1.5, Math.random()),
                })
            );
        });

        gsap.to(this.container, {
            alpha: 0, // Fade out the container
            duration: this.duration / 1000,
            delay: 0.5,
            onComplete: () => {
                this.destroy();
            },
        });
    }

    update(): void {
        const prc = (performance.now() - this.startTime) / DURATION;
        this.container.position.x = lerp(this.startPosition.x, this.targetPosition.x, Power1.easeOut(prc));
        this.container.position.y = lerp(this.startPosition.y, this.targetPosition.y, Power1.easeOut(prc));
        this.sprite.rotation += this.rotation * Time.deltaTime;
    }

    destroy() {
        this.yoyo.forEach((tween) => {
            tween.kill();
        });
        super.destroy();
        this.sprite.removeFromParent();
        this.container.removeFromParent();
    }
}
